/**
 * fechaColombiana -- el formateador UNICO de fechas y horas para las vistas (contrato de vista, regla fecha_a_mano,
 * Ares #42423). Hoy 34 vistas arman la fecha a mano con toLocaleDateString, toLocaleTimeString, Intl.DateTimeFormat o
 * toLocaleString con opciones de fecha. Esta pieza recibe las MISMAS opciones, asi pasar una vista no cambia nada de
 * lo que se ve; la zona horaria tampoco se toca (la decide quien llama con timeZone, como hoy).
 *
 * Regla pura, sin DOM: vive en domain para que application la use; las vistas la importan de
 * presentation/shared/fechaColombiana.js. Lo prueba scripts/check-formatos.mjs.
 *
 * @module domain/value-objects/fechaColombiana
 */

const METODO = { fecha: 'toLocaleDateString', hora: 'toLocaleTimeString', todo: 'toLocaleString' };

/**
 * @param {Date|string|number|null|undefined} f  una fecha, un texto ISO o milisegundos
 * @param {Intl.DateTimeFormatOptions} [opciones] las mismas de toLocaleDateString / toLocaleTimeString / toLocaleString
 * @param {{ parte?: 'fecha'|'hora'|'todo', locale?: string }} [como] parte: que metodo de Date reemplaza (por defecto
 *        'fecha' = toLocaleDateString); locale 'es-CO' por defecto
 * @returns {string} '—' si no hay fecha o no es valida (nunca "Invalid Date" en pantalla)
 */
export function formatearFecha(f, opciones = {}, { parte = 'fecha', locale = 'es-CO' } = {}) {
  if (f === null || f === undefined || f === '') return '—';
  const d = f instanceof Date ? f : new Date(f);
  if (isNaN(d.getTime())) return '—';
  return d[METODO[parte] || METODO.fecha](locale, opciones);
}
